import { render, staticRenderFns } from "./interactionPanel.vue?vue&type=template&id=bb638f68&"
import script from "./interactionPanel.vue?vue&type=script&lang=js&"
export * from "./interactionPanel.vue?vue&type=script&lang=js&"
import style0 from "./interactionPanel.vue?vue&type=style&index=0&id=bb638f68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports